/**
 * Returns current photo by specified config
 * @param {Array} photos
 * @param {object} params
 * @param {string} [params.key]
 * @param {number} [params.index]
 * @returns {object}
 */
export function getCurrentPhoto(photos = [], params = {}) {
  let photo;

  // first find photo
  if ('key' in params) {
    photo = photos.find((p) => p.key === params.key);
  } else if ('index' in params) {
    if (params.index < photos.length) {
      photo = photos[params.index];
    }
  }

  if (photo) {
    if (photo.defaultValue) {
      return { photo, defaultValue: photo.defaultValue };
    }

    if (photo.alive === 1) {
      return { photo };
    }
    return { error: 'wrong uploaded photo(s)' };
  }

  return {};
}
